import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';

var PieChart = function PieChart(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none"
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("rect", {
      width: 35,
      height: 35,
      rx: 5,
      fill: "#7A41F8"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.955 8v9.036H28A9.043 9.043 0 0018.955 8zm-1.91 20a9.046 9.046 0 009.046-9.045h-9.046l-.009-9.037A9.04 9.04 0 1017.046 28z",
      fill: "#fff"
    })]
  }));
};

export default PieChart;